<div class="dash1">
<div style="width: 100%;">
    <app-sidenav></app-sidenav>
    </div>
<!-- <div style="width: 20%;"><app-profile></app-profile></div> -->
</div>
